import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import { addBreadcrumb } from "/redux/action-creaters/breadcrumbs";
import { wrapper } from "/redux";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";

export default function PrivacyPage({ scripts, host }) {
  const { content } = useSelector((state) => state.meta);
  const { contacts } = useSelector((state) => state.contacts);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div className="container text">
        <div className={styles.Text}>
          <div
            dangerouslySetInnerHTML={{
              __html: content
                ?.replaceAll("#SITE#", host)
                ?.replaceAll("#PHONE#", contacts?.phone)
                ?.replaceAll("#CALL_TOUCH_CODE#", contacts?.calltouchCode),
            }}
          />
        </div>
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ req, query, resolvedUrl }) => {
      store.dispatch(
        addBreadcrumb({ link: "/dogovor-oferty/", name: "Договор" }),
      );

      return pagesWrapper(
        { pageType: SITE_PAGE_TYPE.static },
        store,
        Redis,
        {
          query,
          req,
          resolvedUrl,
        },
        "/dogovor-oferty/",
      );
    },
);
